import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel initialization
function MetaPixel() {
  useEffect(() => {
    // Initialize fbq function
    const win = window as any;
    win.fbq = function () {
      win.fbq.callMethod ? win.fbq.callMethod.apply(win.fbq, arguments) : win.fbq.queue.push(arguments);
    };
    if (!win._fbq) win._fbq = win.fbq;
    win.fbq.push = win.fbq;
    win.fbq.loaded = true;
    win.fbq.version = '2.0';
    win.fbq.queue = [];
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel and track PageView
    script.onload = () => {
      win.fbq('init', '431177316638551');
      win.fbq('track', 'PageView');
    };
  }, []);
  return <noscript data-id="element-287">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=431177316638551&ev=PageView&noscript=1" alt="" data-id="element-288" />
    </noscript>;
}
function AppWithPixel() {
  return <>
      <MetaPixel data-id="element-289" />
      <App data-id="element-290" />
    </>;
}
render(<AppWithPixel data-id="element-291" />, document.getElementById('root'));